import {
  Merge, Minimize2, Scissors, FileText, FileOutput,
  AlignLeft, Eye, Table2, ImageDown, RotateCw, Trash2, Lock
} from "lucide-react";
import { Link } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import { buildLocalizedPath } from "../i18nConfig";

const ICON_MAP = { Merge, Minimize2, Scissors, FileText, FileOutput, AlignLeft, Eye, Table2, ImageDown, RotateCw, Trash2, Lock };

export default function ToolCard({ slug, icon, color, title, description }) {
  const { lang } = useLanguage();
  const Icon = ICON_MAP[icon] || FileText;

  return (
    <Link
      to={buildLocalizedPath(slug, lang)}
      data-testid={`tool-card-${slug}`}
      className="block group bg-white rounded-xl border border-slate-200 shadow-sm p-6 hover:shadow-md hover:-translate-y-1 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
    >
      <div
        className="w-12 h-12 rounded-xl flex items-center justify-center mb-4"
        style={{ backgroundColor: `${color}15` }}
      >
        <Icon className="w-6 h-6" style={{ color }} />
      </div>
      <h3
        className="font-semibold text-slate-900 mb-2 group-hover:text-blue-600 transition-colors"
        style={{ fontFamily: "'Outfit', sans-serif", fontSize: "1rem" }}
      >
        {title}
      </h3>
      <p className="text-sm text-slate-500 leading-relaxed">{description}</p>
    </Link>
  );
}
